import _ from 'lodash';
import {
    FETCH_AI_TRANSACTIONS,
    CLEAN_AI_TRANSACTIONS,
} from './types';
import { request, __ } from '../functions';

export const fetchAiTransactions = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/ai-transactions', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_AI_TRANSACTIONS, payload: data });
    });
};

export const cleanAiTransactions = () => ({ type: CLEAN_AI_TRANSACTIONS });
